import { handleColorType } from '@quizzach/styles';
import { useState } from 'react';
import { useTheme } from 'styled-components';

export const ThumbsUp = ({
	color,
	size,
}: {
	color?: string;
	size?: number;
}) => {
	const [isHovered, setIsHovered] = useState(false);
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onTouchStart={() => setIsHovered(false)}
			onTouchEnd={() => setIsHovered(false)}
			style={{
				transform: isHovered ? 'scale(1.1)' : 'scale(1)',
				transition: 'transform 0.3s ease, fill 0.3s ease',
			}}
		>
			<path
				d='M1.66773 15.0927C2.04713 15.342 0.332924 14.5521 5.12917 16.8565C5.96504 17.19 7.91099 18.0874 8.79625 18.237M8.79625 18.237C9.80093 18.4067 10.05 17.9793 10.7498 17.0427C10.9643 16.7556 12.6841 14.8094 12.9334 14.5521C13.1735 14.3041 14.3484 13.2037 15.1741 8.73974C15.2425 8.12184 15.3553 7.51381 15.4204 6.89388C15.4448 6.66204 15.4419 6.43584 15.4534 6.20367C15.4673 5.92425 15.5485 5.65119 15.5677 5.37269C15.6218 4.59179 16.0363 3.706 16.5727 3.15221C17.0474 2.66207 17.7414 2.16117 18.411 2.04197C19.3659 1.87198 21.6899 2.17824 23.0179 3.70618C23.8448 4.64533 24.3633 5.9173 24.5352 7.15952C24.648 7.97521 24.5066 13.1372 24.5066 13.9595C24.5463 14.5113 24.5256 15.0892 24.4846 15.6396C24.4474 16.139 24.3894 16.6366 24.3131 17.129C24.2863 17.302 24.1975 17.4744 24.1284 17.633C24.0836 17.7358 24.1237 17.8796 24.0888 17.9918C24.0608 18.0818 23.8578 18.1212 23.6814 18.1405M8.79625 18.237C8.92204 18.1012 8.94705 39.2109 8.94705 37.5425C10.991 37.4883 23.6131 40.5891 27.6175 39.9C39.6318 38.5218 39.263 33.6546 40.3772 29.0528C42.3794 20.7837 39.0414 19.4056 37.5685 18.7165C36.3728 18.2438 36.1983 18.3451 35.599 18.246C34.6957 18.1839 29.9358 18.1481 29.0303 18.1598C28.3247 18.1689 26.1342 18.246 25.4258 18.246C25.1416 18.246 24.8566 18.2528 24.5726 18.2438C24.2734 18.2343 23.9784 18.1715 23.6814 18.1405M8.79625 18.237C8.63958 18.4061 9.06921 37.4267 8.87051 37.5425C8.94788 36.634 6.33924 40.5891 1 39.9M23.6814 18.1405C23.5768 18.1519 23.4815 18.1562 23.4379 18.1598C23.1379 18.1841 21.8793 18.1423 21.5863 18.1234C21.3379 18.1074 22.2149 18.0826 22.5539 18.0826C22.8433 18.0826 23.1271 18.1189 23.4159 18.1234C23.5047 18.1248 23.5932 18.1313 23.6814 18.1405Z'
				stroke={
					isHovered
						? '#00FFC2'
						: color
							? handleColorType(color, theme)
							: '#00FFC2'
				}
				strokeWidth='2'
				strokeLinecap='round'
			/>
		</svg>
	);
};
